import type { CheckResultDisplay } from './checkResult';
import styles from './ProjectScorecards.module.css';

interface CheckSegmentsProps {
  passing: number;
  failing: number;
  total: number;
}

export const CheckSegments = ({
  passing,
  failing,
  total,
}: CheckSegmentsProps) => (
  <span className={styles.checkSegments}>
    {Array.from({ length: total }, (_, i) => {
      let result: CheckResultDisplay;
      if (i < passing) result = 'passed';
      else if (i < passing + failing) result = 'failed';
      else result = 'no-run';
      return (
        <span key={i} className={styles.checkSegment} data-result={result} />
      );
    })}
  </span>
);
